import React from 'react';
import ChoroplethPattern from './ChoroplethPattern';

export default class ChoroplethCirclePattern extends ChoroplethPattern {
  render() {
    return (
      <pattern id={this.props.patternName} width="15" height="15" patternUnits="userSpaceOnUse">
        <rect x="0" y="0" width="15" height="15" fill={this.getBackgroundColor()}/>
        <circle cx="7" cy="7" r={1.1 * this.props.patternSize} fill={this.getPatternColor()}/>
      </pattern>
    );
  };
}
